import { Col, Row } from 'antd';
import React from 'react';
import StatCard from './StatCard';
import { DemoStatsProps } from '../../libs/types/src';

const DemoStats: React.FC<DemoStatsProps> = ({ stats }) => {
    const currentStats = [
        { label: 'Total Demos', value: stats?.total_demos || 0 },
        { label: 'Analyzed', value: stats?.completed_count || 0 },
        { label: 'Key Features Identified', value: stats?.key_features_identified || 0 },
        { label: 'Avg. Analysis Time', value: stats?.avg_analysis_time || 0 },
    ];

    return (
        <Row gutter={[16, 16]} className="demos-stats-row">
            {currentStats.map((stat, idx) => (
                <Col xs={24} sm={12} md={6} key={stat.label}>
                    <StatCard label={stat.label} value={stat.value?.toString()} />
                </Col>
            ))}
        </Row>
    );
};

export default DemoStats; 